import { usePostHog as nativeUsePostHog } from 'posthog-js/react'

import { isPosthogEnabled } from './constants'

export function usePostHog() {
  const posthog = nativeUsePostHog()

  return isPosthogEnabled ? posthog : null
}
